var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgIconTwitterNew = function SvgIconTwitterNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h16v16H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.355 4.99c.01.132.01.263.01.394 0 4.003-3.299 8.616-9.33 8.616A9.833 9.833 0 010 12.64c.264.029.518.038.792.038a6.921 6.921 0 004.071-1.294c-1.442-.028-2.65-.9-3.066-2.1.203.028.406.047.62.047.294 0 .588-.037.862-.103C1.777 8.947.65 7.728.65 6.256V6.22c.437.225.945.365 1.483.384C1.249 6.06.67 5.131.67 4.081c0-.562.162-1.078.447-1.528 1.614 1.838 4.04 3.038 6.761 3.169a3.167 3.167 0 01-.081-.694C7.797 3.36 9.259 2 11.077 2c.943 0 1.796.366 2.395.956a6.79 6.79 0 002.081-.731c-.243.703-.761 1.294-1.441 1.669.66-.066 1.3-.235 1.888-.469a6.78 6.78 0 01-1.645 1.566z",
    fill: "#1DA1F2"
  })));
};
export default SvgIconTwitterNew;